import React from "react";
import PropTypes from "prop-types";
import { TermsDivision, Disclaimer, AnchorTag } from "../style";
import {
  DisplayFlex,
  CustomCheckbox,
} from "../../../../../../../CommonComponents/commonStyles";
import {
  ErrorMsgWrap,
  GrantSectionHeading,
  CheckboxLabel,
  UnderlyingContent,
} from "../../../style";
import Contents from "../../../../../../../CommonComponents/ContentMessages";

const DisclaimerLayout = ({
  value,
  handleChange,
  showError,
  content,
  isGaw = false,
}) => {
  return (
    <Disclaimer>
      <GrantSectionHeading>Disclaimer</GrantSectionHeading>
      {content}
      <TermsDivision>
        <DisplayFlex>
          <CustomCheckbox
            id="chkDisclaimer"
            aria-label="disclaimer"
            checked={value}
            onChange={handleChange}
          />
          {isGaw ? (
            <CheckboxLabel>
              By checking this box and clicking submit you certify on behalf of
              all authorized parties on this account that the information above
              is correct. You also certify that you have read Vanguard
              Charitable's
              <UnderlyingContent
                href="/company-policies/policies-and-guidelines"
                target="_blank"
                alt="Policies and guidelines"
                id="anrPolicies_Guidelines"
              >
                {" "}
                Policies & Guidelines
              </UnderlyingContent>{" "}
              booklet.
            </CheckboxLabel>
          ) : (
            <CheckboxLabel>
              <Contents.Consumer>
                {(props) => {
                  if (
                    props.page_checkbox &&
                    props.page_checkbox["Recommend a Grant"]
                  ) {
                    const extractedData = props.page_checkbox[
                      "Recommend a Grant"
                    ].filter((item) => item.name === "Submit Grant");
                    return <AnchorTag dangerouslySetInnerHTML={{ __html: extractedData && extractedData[0].field_checkbox_conent }}></AnchorTag>
                  }
                }}
              </Contents.Consumer>
            </CheckboxLabel>
          )}
        </DisplayFlex>
      </TermsDivision>
      {showError && (
        <ErrorMsgWrap>
          Please read the certification statement and check the box to proceed.
        </ErrorMsgWrap>
      )}
    </Disclaimer>
  );
};

DisclaimerLayout.propTypes = {
  value: PropTypes.bool,
  handleChange: PropTypes.func,
  showError: PropTypes.bool,
  content: PropTypes.elementType,
  isGaw: PropTypes.bool,
};

export default DisclaimerLayout;
